import ItiLanguageSelectorLogin from "@/iti-core-react/components/ItiLanguageSelectorLogin/ItiLanguageSelectorLogin";
import ItiSelectBoxComponent from "@/iti-core-react/components/ItiSelectBox/ItiSelectBox";
import ItiTextBoxComponent from "@/iti-core-react/components/ItiTextBox/ItiTextBox";
import SentryTest from "@/shared/components/SentryTest";

export default function Style() {
	return (
		<>
			<div>
				<h2>Style</h2>
			</div>

			<SentryTest />

			<div className="row ps-3">
				<ItiLanguageSelectorLogin />
			</div>

			<div className="row">
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba LG"
						textBoxAttributes={{ class: "field-lg-shadow" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba MD"
						textBoxAttributes={{ class: "field-md-shadow" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba SM"
						textBoxAttributes={{ class: "field-sm-shadow" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba LG"
						textBoxAttributes={{ class: "field-lg" }}
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba MD"
						textBoxAttributes={{ class: "field-md" }}
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba SM"
						textBoxAttributes={{ class: "field-sm" }}
						placeholder="Placeholder test"
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-auto">
					<ItiSelectBoxComponent
						label="Texto de prueba LG"
						elementAttr={{ class: "select-lg" }}
						labelClass="dark-label"
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiSelectBoxComponent
						label="Texto de prueba MD"
						elementAttr={{ class: "select-md" }}
						labelClass="dark-label"
						placeholder="Placeholder test"
					/>
				</div>
				<div className="col-auto">
					<ItiSelectBoxComponent
						label="Texto de prueba SM"
						elementAttr={{ class: "select-sm" }}
						labelClass="dark-label"
						placeholder="Placeholder test"
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba LG"
						textBoxAttributes={{ class: "field-lg" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
						disabled={true}
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba MD"
						textBoxAttributes={{ class: "field-md" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
						disabled={true}
					/>
				</div>
				<div className="col-auto">
					<ItiTextBoxComponent
						label="Texto de prueba SM"
						textBoxAttributes={{ class: "field-sm" }}
						labelClass="dx-field-item-label-text-light"
						placeholder="Placeholder test"
						disabled={true}
					/>
				</div>
			</div>
		</>
	);
}
